import { useNavigate } from "react-router-dom";

function TableRow({ link, children, onClick }) {
  const navigate = useNavigate();

  return (
    <tr
      className={`custom_transition group leading-[22px] font-normal odd:bg-white even:bg-gray-100 hover:bg-gray-100 duration-300 ${
        (onClick || link) && "cursor-pointer"
      }`}
      style={{ height: 38 }}
      onClick={() => {
        if (onclick) {
          return onclick();
        } else if (link) {
          navigate(link);
        }
      }}
    >
      {children}
    </tr>
  );
}

export default TableRow;
